module.exports = __webpack_public_path__ + "public/img/portfolio.8b5336d.jpeg";